<template>
    <div id="topic-management-detail">
        <v-breadcrumbs :items="items" divider="|"> </v-breadcrumbs>

        <h3 class="header-text font-weight-bold">{{ subject.nama }}</h3>

        <v-card>
            <v-card-text class="py-0 px-1 ma-0">
                <v-container fluid>
                    <v-row no-gutters>
                        <v-col cols="*">
                            <v-text-field
                                v-model="searchQuery"
                                outlined
                                height="36px"
                                hide-details
                                small
                                dense
                                class="search_box"
                                placeholder="Ketik kata kunci dan tekan enter"
                            >
                                <template slot="prepend-inner">
                                    <svg
                                        style="margin-top: 10px !important"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M8.33342 15.0001C9.81256 14.9998 11.2491 14.5046 12.4142 13.5934L16.0776 17.2567L17.2559 16.0784L13.5926 12.4151C14.5042 11.2498 14.9997 9.81295 15.0001 8.33341C15.0001 4.65758 12.0092 1.66675 8.33342 1.66675C4.65758 1.66675 1.66675 4.65758 1.66675 8.33341C1.66675 12.0092 4.65758 15.0001 8.33342 15.0001ZM8.33342 3.33341C11.0909 3.33341 13.3334 5.57591 13.3334 8.33341C13.3334 11.0909 11.0909 13.3334 8.33342 13.3334C5.57591 13.3334 3.33341 11.0909 3.33341 8.33341C3.33341 5.57591 5.57591 3.33341 8.33342 3.33341Z"
                                            fill="#073554"
                                        />
                                        <path
                                            d="M9.50994 7.15507C9.82577 7.47174 9.99994 7.89007 9.99994 8.33341H11.6666C11.6673 7.89543 11.5813 7.46165 11.4133 7.05714C11.2454 6.65264 10.999 6.28543 10.6883 5.97674C9.4266 4.71674 7.2391 4.71674 5.97827 5.97674L7.15494 7.15674C7.78827 6.52507 8.87994 6.52674 9.50994 7.15507Z"
                                            fill="#073554"
                                        />
                                    </svg>
                                </template>
                                <template slot="append-outer">
                                    <v-btn
                                        class="align-center text-body-2 blew white--text"
                                        plain
                                        dark
                                        @click="showNewTopicDialog = true"
                                        ><v-icon small class="pr-2"
                                            >mdi-plus-circle</v-icon
                                        >
                                        Topik
                                    </v-btn>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text class="pa-4">
                <v-row>
                    <v-col
                        cols="4"
                        class="pa-3"
                        v-for="card in filteredCards"
                        v-bind:key="card.id"
                    >
                        <v-card flat outlined>
                            <v-card-title>
                                <v-list class="pa-0 ma-0" width="100%">
                                    <v-list-item class="pa-0 ma-0">
                                        <v-list-item-content class="pa-0 ma-0">
                                            <v-list-item-title
                                                class="text-subtitle-1 font-weight-bold black--text"
                                                style="
                                                    word-break: break-word !important;
                                                "
                                            >
                                                {{ card.nama }}
                                            </v-list-item-title>
                                        </v-list-item-content>

                                        <v-list-item-action
                                            class="pa-0 ma-0 align-self-start justify-self-end"
                                        >
                                            <v-btn
                                                icon
                                                small
                                                color="redLight"
                                                @click="
                                                    showDeleteConfirmation(card)
                                                "
                                                ><v-icon
                                                    >mdi-close-circle</v-icon
                                                ></v-btn
                                            >
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </v-card-title>
                            <v-card-subtitle>{{ card.kode }}</v-card-subtitle>
                            <v-card-actions>
                                <v-col
                                    cols="*"
                                    class="pa-0 ma-0 d-flex justify-center"
                                >
                                    <v-btn
                                        color="blew"
                                        text
                                        @click="showDetail(card)"
                                        >Ubah Data</v-btn
                                    >
                                </v-col>
                                <v-col
                                    cols="6"
                                    v-if="!subTopic && !$route.query.topic_id"
                                    class="pa-0 ma-0 d-flex justify-center"
                                >
                                    <v-btn
                                        color="blew"
                                        text
                                        :to="
                                            topic && !subTopic
                                                ? {
                                                      path: '/topic-management/detail',
                                                      query: {
                                                          subject_id:
                                                              subject.id,
                                                          topic_id: topic.id,
                                                          sub_topic_id: card.id,
                                                      },
                                                  }
                                                : {
                                                      path: '/topic-management/detail',
                                                      query: {
                                                          subject_id:
                                                              subject.id,
                                                          topic_id: card.id,
                                                      },
                                                  }
                                        "
                                        style="text-decoration: none"
                                        >Lihat Sub-Bab</v-btn
                                    >
                                </v-col>
                                <v-col
                                    cols="6"
                                    v-if="!subTopic && $route.query.topic_id"
                                    class="pa-0 ma-0 d-flex justify-center"
                                >
                                    <v-btn
                                        color="blew"
                                        text
                                        :to="
                                            topic && !subTopic
                                                ? {
                                                      path: '/topic-management/detail',
                                                      query: {
                                                          subject_id:
                                                              subject.id,
                                                          topic_id: topic.id,
                                                          sub_topic_id: card.id,
                                                      },
                                                  }
                                                : {
                                                      path: '/topic-management/detail',
                                                      query: {
                                                          subject_id:
                                                              subject.id,
                                                          topic_id: card.id,
                                                      },
                                                  }
                                        "
                                        style="text-decoration: none"
                                        >Lihat Sub-Sub-Bab</v-btn
                                    >
                                </v-col>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                    <v-col v-if="!filteredCards.length">
                        <div cols="12" class="pa-3 text-center">
                            Data tidak tersedia
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-dialog
            v-model="showNewTopicDialog"
            transition="dialog-top-transition"
            width="940px"
            min-height="537px"
            max-height="771px"
            @click:outside="showNewTopicDialog = false"
            scrollable
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title width="100%">
                        Tambah Topik Baru
                    </v-card-title>
                    <v-card-text class="px-0" width="100%">
                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Induk
                                </v-list-item-title>
                                <v-text-field
                                    v-model="topicParentName"
                                    filled
                                    outlined
                                    disabled
                                />
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item two-line>
                            <v-list-item-content class="pa-0">
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Nama *
                                </v-list-item-title>
                                <v-text-field
                                    v-model="formTopicName"
                                    placeholder="Nama Topik"
                                    outlined
                                />
                            </v-list-item-content>
                        </v-list-item>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn text @click="dialog.value = false">Close</v-btn>
                        <v-btn dark color="blew" @click="addNewTopic()"
                            >Simpan</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <v-dialog
            v-model="showModal"
            transition="dialog-top-transition"
            width="940px"
            min-height="537px"
            max-height="771px"
            @click:outside="showModal = false"
            scrollable
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title width="100%"> Detail Topik </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="px-0 py-0" width="100%">
                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Induk
                                </v-list-item-title>
                                <v-text-field
                                    v-model="selectedTopic.parentName"
                                    filled
                                    outlined
                                    disabled
                                />
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                            <v-list-item-content class="pa-0">
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Kode
                                </v-list-item-title>
                                <v-text-field
                                    v-model="selectedTopic.code"
                                    filled
                                    outlined
                                    disabled
                                />
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                            <v-list-item-content class="pa-0">
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Nama *
                                </v-list-item-title>
                                <v-text-field
                                    v-model="selectedTopic.name"
                                    placeholder="Nama Topik"
                                    outlined
                                />
                            </v-list-item-content>
                        </v-list-item>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn text @click="dialog.value = false">Close</v-btn>
                        <v-btn dark color="blew" @click="updateTopic()"
                            >Simpan</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <v-dialog
            v-if="showConfirmationModal"
            v-model="showConfirmationModal"
            @click:outside="showConfirmationModal = false"
            max-width="290"
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title style="word-break: break-word !important">
                        Apakah ada yakin akan menghapus topik
                        <strong style="color: red"
                            >{{ selectedTopic.name }}
                        </strong>
                        ?
                    </v-card-title>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                            color="red darken-1"
                            text
                            @click="dialog.value = false"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                            color="blew darken-1"
                            text
                            @click="deleteTopic()"
                        >
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import ItembankService from "@/modules/itembank/services/itembank.js";
import Modal from "@/modules/global/components/plugins/Modal";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "topic-management-detail",

    data: function () {
        return {
            subject: null,
            topic: null,
            subTopic: null,
            subSubTopic: null,
            cards: [],
            filteredCards: [],
            topics: [],
            bgColors: ["bg-green", "bg-blue", "bg-purple", "bg-red"],
            searchQuery: "",
            showModal: false,
            showConfirmationModal: false,
            selectedTopic: null,
            isLoading: false,
            formTopicName: "",
            showNewTopicDialog: false,
            errors: [],
            items: [],
        };
    },

    components: {
        "app-modal": Modal,
        "app-spinner": Spinner,
    },

    watch: {
        "$route.query.topic_id": function (val) {
            var context = this;
            context.searchQuery = "";

            if (!val) {
                context.topic = null;
                context.cards = context.topics;
                context.filteredCards = context.cards;
            } else {
                var topicId = parseInt(val);
                var found = context.cards.find(function (card) {
                    return card.id === topicId;
                });

                context.topic = found;
                context.cards = context.topic.subs;
                context.filteredCards = context.cards;
            }
            context.breadcrumbs();
        },
        "$route.query.sub_topic_id": function (val) {
            var context = this;
            context.searchQuery = "";

            if (!val) {
                context.subTopic = null;
                if (context.topic) {
                    context.cards = context.topic.subs;
                    context.filteredCards = context.cards;
                }
            } else {
                var subTopicId = parseInt(val);
                var found = context.cards.find(function (card) {
                    return card.id === subTopicId;
                });
                context.subTopic = found;
                context.cards = context.subTopic.subs;
                context.filteredCards = context.cards;
            }

            context.breadcrumbs();
        },

        searchQuery: function (val) {
            if (val.length === 0) this.filteredCards = this.cards;
            this.filteredCards = this.cards.filter(function (card) {
                return card.nama.toLowerCase().includes(val.toLowerCase());
            });
        },
    },

    computed: {
        topicParentName: function () {
            if (this.topic) return this.topic.nama;
            if (this.subTopic) return this.subTopic.nama;

            return this.subject.nama;
        },
    },

    methods: {
        breadcrumbs: function () {
            this.items = [];

            this.items.push(
                { text: "Kodifikasi", to: { path: "/" } },
                {
                    text: "Pengaturan Bab",
                    to: { path: "/topic-management" },
                    exact: true,
                },
                {
                    text: this.subject.nama,
                    to: {
                        path: "/topic-management/detail",
                        query: { subject_id: this.subject.id },
                    },
                    exact: true,
                },
            );

            if (this.topic) {
                this.items.push({
                    text: this.topic.nama,
                    to: {
                        path: "/topic-management/detail",
                        query: {
                            subject_id: this.subject.id,
                            topic_id: this.topic.id,
                        },
                    },
                    exact: true,
                });
            }

            if (this.subTopic) {
                this.items.push({
                    text: this.subTopic.nama,
                    to: {
                        path: "/topic-management/detail",
                        query: {
                            subject_id: this.subject.id,
                            topic_id: this.topic.id,
                            sub_topic_id: this.subTopic.id,
                        },
                    },
                    exact: true,
                });
            }
        },

        bgColor: function (id) {
            var index = id % 4;
            return this.bgColors[index];
        },

        renderPicture: function (path) {
            return !path
                ? "https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png"
                : path;
        },

        truncateText: function (text, length) {
            if (text.length <= length) return text;

            return text.substring(0, length) + "...";
        },

        updateSelectedTopic: function (card) {
            var parentName = this.subject.nama;
            var parentId = this.subject.id;

            if (this.topic) {
                parentId = this.topic.id;
                parentName = this.topic.nama;
            }

            if (this.subTopic) {
                parentId = this.subTopic.id;
                parentName = this.subTopic.nama;
            }

            var selectedTopic = {
                id: card.id,
                parentId: parentId,
                parentName: parentName,
                name: card.nama,
                code: card.kode,
            };

            this.selectedTopic = selectedTopic;
        },

        showDetail: function (card) {
            this.updateSelectedTopic(card);
            this.showModal = true;
        },

        showDeleteConfirmation: function (card) {
            this.updateSelectedTopic(card);
            this.showConfirmationModal = true;
        },

        updateTopic: function () {
            if (this.selectedTopic.name.length === 0) {
                this.$store.commit("showAlert", {
                    message: `Nama wajid diisi!`,
                    type: "error",
                });
                this.showModal = false;
                return;
            }

            if (this.subTopic) this.doUpdateSubSubBab();
            else if (this.topic) this.doUpdateSubBab();
            else this.doUpdateBab();
        },

        doUpdateBab: function () {
            var data = {
                mapel_id: this.subject.id,
                name: this.selectedTopic.name,
            };

            var context = this;
            var babId = this.selectedTopic.id;
            this.isLoading = true;

            ItembankService.updateBab(babId, data, function (response) {
                if (response.success) {
                    var index = context.cards.findIndex(function (card) {
                        return card.id === babId;
                    });

                    var card = context.cards[index];
                    card.nama = response.data.nama;

                    context.$set(context.cards, index, card);
                    context.isLoading = false;
                    context.showModal = false;
                }
            });
        },

        doUpdateSubBab: function () {
            var data = {
                bab_id: this.selectedTopic.parentId,
                name: this.selectedTopic.name,
            };

            var context = this;
            var id = this.selectedTopic.id;
            this.isLoading = true;

            ItembankService.updateSubBab(id, data, function (response) {
                if (response.success) {
                    var index = context.cards.findIndex(function (card) {
                        return card.id === id;
                    });

                    var card = context.cards[index];
                    card.nama = response.data.nama;

                    context.$set(context.cards, index, card);
                    context.isLoading = false;
                    context.showModal = false;
                }
            });
        },

        doUpdateSubSubBab: function () {
            var data = {
                subbab_id: this.selectedTopic.parentId,
                name: this.selectedTopic.name,
            };

            var context = this;
            var id = this.selectedTopic.id;
            this.isLoading = true;

            ItembankService.updateSubSubBab(id, data, function (response) {
                if (response.success) {
                    var index = context.cards.findIndex(function (card) {
                        return card.id === id;
                    });

                    var card = context.cards[index];
                    card.nama = response.data.nama;

                    context.$set(context.cards, index, card);
                    context.isLoading = false;
                    context.showModal = false;
                }
            });
        },

        deleteTopic: function () {
            if (this.subTopic) this.doDeleteSubSubBab();
            else if (this.topic) this.doDeleteSubBab();
            else this.doDeleteBab();
        },

        doDeleteBab: function () {
            var context = this;
            var id = this.selectedTopic.id;
            this.isLoading = true;

            ItembankService.deleteBab(id, function (response) {
                if (response.success) {
                    var index = context.cards.findIndex(function (card) {
                        return card.id === id;
                    });

                    context.$delete(context.cards, index);
                } else {
                    context.$store.commit("showAlert", {
                        message: `Tidak dapat menghapus bab, pastikan bab tidak termapping dengan soal!`,
                        type: "error",
                    });
                }

                context.showConfirmationModal = false;
                context.isLoading = false;
            });
        },

        doDeleteSubBab: function () {
            var context = this;
            var id = this.selectedTopic.id;
            this.isLoading = true;

            ItembankService.deleteSubBab(id, function (response) {
                if (response.success) {
                    var index = context.cards.findIndex(function (card) {
                        return card.id === id;
                    });

                    context.$delete(context.cards, index);
                } else {
                    context.$store.commit("showAlert", {
                        message: `Tidak dapat menghapus sub-bab, pastikan sub-bab tidak termapping dengan soal!`,
                        type: "error",
                    });
                }

                context.showConfirmationModal = false;
                context.isLoading = false;
            });
        },

        doDeleteSubSubBab: function () {
            var context = this;
            var id = this.selectedTopic.id;
            this.isLoading = true;

            ItembankService.deleteSubSubBab(id, function (response) {
                if (response.success) {
                    var index = context.cards.findIndex(function (card) {
                        return card.id === id;
                    });

                    context.$delete(context.cards, index);
                } else {
                    context.$store.commit("showAlert", {
                        message: `Tidak dapat menghapus sub-sub-bab, pastikan sub-sub-bab tidak termapping dengan soal!`,
                        type: "error",
                    });
                }

                context.showConfirmationModal = false;
                context.isLoading = false;
            });
        },

        addNewTopic: function () {
            if (this.formTopicName === "") {
                this.$store.commit("showAlert", {
                    message: `Nama wajid diisi!`,
                    type: "error",
                });
                this.showNewTopicDialog = false;
                return false;
            }

            if (this.subTopic) this.doAddSubSubBab();
            else if (this.topic) this.doAddSubBab();
            else this.doAddBab();
        },

        doAddBab: function () {
            var data = {
                mapel_id: this.subject.id,
                name: this.formTopicName,
            };

            var context = this;
            this.isLoading = true;
            ItembankService.addBab(data, function (response) {
                if (response.success) {
                    var card = {
                        id: response.data.id,
                        nama: response.data.nama,
                        kode: response.data.kode,
                        subs: [],
                    };

                    context.cards.push(card);
                    context.formTopicName = "";
                    context.isLoading = false;
                    context.showNewTopicDialog = false;
                }
            });
        },

        doAddSubBab: function () {
            var data = {
                bab_id: this.topic.id,
                name: this.formTopicName,
            };

            var context = this;
            this.isLoading = true;
            ItembankService.addSubBab(data, function (response) {
                if (response.success) {
                    var card = {
                        id: response.data.id,
                        nama: response.data.nama,
                        kode: response.data.kode,
                        subs: [],
                    };

                    context.cards.push(card);

                    context.formTopicName = "";
                    context.isLoading = false;
                    context.showNewTopicDialog = false;
                }
            });
        },

        doAddSubSubBab: function () {
            var data = {
                subbab_id: this.subTopic.id,
                name: this.formTopicName,
            };

            var context = this;
            this.isLoading = true;
            ItembankService.addSubSubBab(data, function (response) {
                if (response.success) {
                    var card = {
                        id: response.data.id,
                        nama: response.data.nama,
                        kode: response.data.kode,
                    };

                    context.cards.push(card);
                    context.formTopicName = "";
                    context.isLoading = false;
                    context.showNewTopicDialog = false;
                }
            });
        },

        readParams() {
            var context = this;
            if (
                context.$route.query.topic_id &&
                context.$route.query.sub_topic_id
            ) {
                const found = context.cards.find(
                    (x) => x.id == Number(context.$route.query.topic_id),
                );
                const found_sub = found.subs.find(
                    (x) => x.id == Number(context.$route.query.sub_topic_id),
                );

                this.topic = found;
                this.subTopic = found_sub;
                this.filteredCards = found_sub.subs;
            } else if (context.$route.query.topic_id) {
                const found = context.cards.find(
                    (x) => x.id == Number(context.$route.query.topic_id),
                );

                this.topic = found;
                this.filteredCards = found.subs;
            }
            this.breadcrumbs();
        },
    },

    beforeMount: function () {
        var subjectId = this.$route.query.subject_id;
        var subjects = JSON.parse(window.localStorage.getItem("mapels"));
        var found = subjects.find(function (subject) {
            return subject.id == subjectId;
        });

        this.subject = found;
    },

    mounted: function () {
        var context = this;
        ItembankService.getListOfTopic(this.subject.code, function (response) {
            if (response.success) {
                response.data.forEach(function (topic) {
                    context.topics.push(topic);
                });
                context.cards = context.topics;
                context.filteredCards = context.cards;
            }
        });

        this.breadcrumbs();
        setTimeout(() => {
            this.readParams();
        }, 1000);
    },
};
</script>



// WEBPACK FOOTER //
// TopicManagementDetail.vue?59dcdb15